<template>
  <div>
    <v-app>
      <NavegacionIslero v-if="usuario !== null && usuario.rol_codigo === ROL_ISLERO" />
      <v-navigation-drawer permanent :rail="rail" class="drawer-style" mobile-breakpoint="0" touchless
        disable-resize-watcher>
        <v-list>
          <v-list-item-group v-model="menuSeleccionado">
            <v-list-item class="list-item-menu" @click="accionMenu('Autorizaciones')">
              <template v-slot:prepend>
                <v-icon @click.stop="rail = !rail" class="icono-menu-vertical app-text-success">mdi-gas-station</v-icon>
                <v-icon class="icono-flecha app-text-success" small @click.stop="rail = !rail">
                  {{ !rail ? 'mdi-chevron-left' : 'mdi-chevron-right' }}
                </v-icon>
              </template>
              <v-list-item-title>Autorización</v-list-item-title>
            </v-list-item>
            <v-list-item class="list-item-menu" @click="accionMenu('Servicios')">
              <template v-slot:prepend>
                <v-icon @click.stop="rail = !rail"
                  class="icono-menu-vertical app-text-success">mdi-gas-station-in-use-outline</v-icon>
                <v-icon class="icono-flecha app-text-success" small @click.stop="rail = !rail">
                  {{ !rail ? 'mdi-chevron-left' : 'mdi-chevron-right' }}
                </v-icon>
              </template>
              <v-list-item-title>Servicios</v-list-item-title>
            </v-list-item>
            <v-list-item class="list-item-menu" @click="accionMenu('RecogidasEfectivo')">
              <template v-slot:prepend>
                <v-icon @click.stop="rail = !rail" class="icono-menu-vertical app-text-success">mdi-cash-register</v-icon>
                <v-icon class="icono-flecha app-text-success" small @click.stop="rail = !rail">
                  {{ !rail ? 'mdi-chevron-left' : 'mdi-chevron-right' }}
                </v-icon>
              </template>
              <v-list-item-title>R. Efectivo</v-list-item-title>
            </v-list-item>
            <v-list-item class="list-item-menu" @click="accionMenu('CierreTurno')">
              <template v-slot:prepend>
                <v-icon @click.stop="rail = !rail" class="icono-menu-vertical app-text-success">mdi-clock-check-outline</v-icon>
                <v-icon class="icono-flecha app-text-success" small @click.stop="rail = !rail">
                  {{ !rail ? 'mdi-chevron-left' : 'mdi-chevron-right' }}
                </v-icon>
              </template>
              <v-list-item-title>Cerrar Turno</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
      <v-main class="informacion-principal" :style="{ 'padding-left': rail ? '57px' : '175px' }">
        <router-view />
      </v-main>
    </v-app>
  </div>
</template>

<script>
import NavegacionAdmin from '@/components/Navegacion/NavegacionAdmin.vue'
import NavegacionIslero from '@/components/Navegacion/NavegacionIslero.vue'
import NavegacionCliente from '@/components/Navegacion/NavegacionCliente.vue'
import Footer from '@/components/parciales/Footer.vue'
import { mapGetters, mapActions } from "vuex";
import { Constantes } from '@/util/Constantes';

export default {
  name: 'MainLayout',
  components: {
    NavegacionAdmin,
    NavegacionCliente,
    NavegacionIslero,
    Footer
  },
  data() {
    return {
      mensaje: { ver: false },
      ruta_servidor: this.axios.defaults.baseURL,
      show: false,
      rail: true,
      menuSeleccionado: null,
      ROL_ADMIN: Constantes.ROL_ADMIN,
      ROL_ISLERO: Constantes.ROL_ISLERO,
      ROL_CLIENTE: Constantes.ROL_CLIENTE
    };
  },
  methods: {
    ...mapActions(['cerrarSesion']),
    accionMenu(opcion) {
      if (opcion === "Autorizaciones" && !this.rail) {
        this.$router.push('/app/islero/autorizaciones-islero')
        this.minimizarMenu()
      } else if (opcion === "Servicios") {
        this.$router.push('/app/islero/servicios-islero')
        this.minimizarMenu()
      } else if (opcion === "RecogidasEfectivo") {
        this.$router.push('/app/islero/recogidas-efectivo-islero')
        this.minimizarMenu()
      } else if (opcion === "CierreTurno") {
        this.$router.push('/app/islero/cierres-turnos-islero')
        this.minimizarMenu()
        //alert('No displonible Actualmente. Próximamente se va a habilitar')
      }else if (opcion === "Cerrar") {
        this.cerrarSesion()
      }
    },
    minimizarMenu() {
      this.rail = !this.rail;
    }
  },
  computed: {
    ...mapGetters(['usuario'])
  }
}
</script>
<style scoped>
.drawer-style {
  max-width: 175px;
  height: 100vh;
  background-color: var(--gray-color);
  z-index: 10;
  transition: max-width 0.2s ease-in-out;
}

.drawer-style .v-list-item {
  color: #000;
  /* Color del texto */
}

.drawer-style :deep(.v-list-item-title) {
  text-align: left;
  font-size: 15px;
}

.drawer-style :deep(.v-list-item__prepend) {
  margin-right: -30px !important;
}

.v-icon {
  text-align: left !important;
}

.v-icon {
  font-size: 32px;
  font-weight: bold;
}
</style>